import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { DividerWithMargin } from 'framework/components/DividerWithMargin';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { useAccordionState } from 'framework/utils/useAccordionState';
import { paymentMethodsQuery_all } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { PaymentMethodDetailContent } from './PaymentMethodDetailContent';
import { PaymentMethodListItem } from './PaymentMethodListItem';
import { PaymentMethodForm } from './forms/PaymentMethodForm';

interface IProps extends IReloadTriggerProps {}

export const PaymentMethodsContent = ({ reloadTrigger }: IProps) => {
	const strings = useLocalization();
	const [all, reload] = useApiEffect(paymentMethodsQuery_all);
	const { open, confirm, cancel } = useDialogsContext(reload);
	const [selectedId, setSelectedId] = useAccordionState<string>();
	const expandedPaymentMethod = useMemo(() => (all ?? []).find(t => t.id === selectedId), [all, selectedId]);

	useLazyEffect(() => {
		reload();
	}, [reloadTrigger]);

	const onNew = () => {
		open(
			<PaymentMethodForm
				open
				confirm={confirm}
				cancel={cancel}
			/>
		);
	};

	if (all === undefined) {
		return <></>;
	}

	return (
		<div
			className='df-row'
			style={{ gap: 24 }}>
			<div className='df-col'>
				<TextLinkButton
					startIcon={<AddCircleOutlineOutlinedIcon />}
					onClick={onNew}
					color='primary'>
					{strings.newWhat(strings.paymentMethod)}
				</TextLinkButton>
				<DividerWithMargin />
				{all.map(t => (
					<PaymentMethodListItem
						key={t.id}
						item={t}
						isSelected={expandedPaymentMethod?.id === t.id}
						toggle={() => setSelectedId(t.id)}
					/>
				))}
			</div>
			{expandedPaymentMethod !== undefined && (
				<PaymentMethodDetailContent
					item={expandedPaymentMethod}
					reload={reload}
				/>
			)}
		</div>
	);
};
